export default __webpack_public_path__ + "static/media/Strippy-Regular.5807b0e7.ttf";